// Devuelve la fecha en formato YYYY-MM-DD en UTC
export function getUTCDateString(date: Date) {
  return date.getUTCFullYear() + '-' +
    String(date.getUTCMonth() + 1).padStart(2, '0') + '-' +
    String(date.getUTCDate()).padStart(2, '0');
}

// Compara si la fecha de vigencia es hoy o posterior (en UTC)
export function isVigente(fechaVigencia: string, activo: boolean) {
  const fechaVigenciaUTC = getUTCDateString(new Date(fechaVigencia));
  const hoyUTC = getUTCDateString(new Date());
  return fechaVigenciaUTC >= hoyUTC && activo;
}

// Devuelve la fecha en formato ISO al final del día (para enviar al backend)
export function getEndOfDayISOString(dateString: string) {
  // dateString: 'YYYY-MM-DD'
  const [year, month, day] = dateString.split('-').map(Number);
  // Crea la fecha en UTC, no local
  const date = new Date(Date.UTC(year, month - 1, day, 23, 59, 59, 999));
  return date.toISOString();
}
